<script>

    import Moment from 'moment'
    import { toast } from 'bulma-toast'
    import { noticesStore, modalStore } from '../stores'

    import NoticesService from '../$services/notices.service'

    import InputNumber from '../$components/input.number.svelte'
    import InputText from '../$components/input.text.svelte'
    import Button from '../$components/button.svelte'
    import Select from '../$components/select.svelte'
    import Date from '../$components/date.svelte'
    import Form from '../$components/form.svelte'
    import File from '../$components/file.svelte'
    import Textarea from '../$components/textarea.svelte'

    export let userId = null

    let loading = false
    let data = {
        expired: Moment().endOf('month').toDate(),
        userId,
    }
    
    async function createNotice() {
    
        loading = true
        const resp = await NoticesService.createNotice(data)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        noticesStore.append(resp.data)
        modalStore.close()
    }

</script>

<Form on:submit={createNotice} { loading } >
    <div class="columns">
        <div class="column">
            <Select 
                bind:value={data.type}
                label="Tipo"
                options={[
                    {value: 'image', text: 'Imagen'},
                    {value: 'video', text: 'Video'},
                    {value: 'text', text: 'Texto'},
                ]}
            />
        </div>
        <div class="column">
            <Select
                bind:value={data.display}
                label="Display"
                options={[
                    {value: 'home', text: 'Home'},
                    {value: 'bar', text: 'Bar'},
                ]}
            />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.title} label="Título" placeholder="Título" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputNumber bind:value={data.index} label="Prioridad" placeholder="Prioridad" />
        </div>
    </div>
    {#if data.type === 'image' || data.type === 'video'}
        <div class="columns">
            <div class="column">
                <File bind:file={data.file} fileDir="notices" label="Archivo" bind:loading />
            </div>
        </div>
    {/if}
    {#if data.type === 'text'}
        <div class="columns">
            <div class="column">
                <Textarea bind:value={data.text} label="Texto" placeholder="Texto" />
            </div>
        </div>
    {/if}
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.link} label="Link" placeholder="Link" required={false} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <Date bind:value={data.expired} label="Fecha de expiración" />
        </div>
    </div>
    <div class="items-end">
        <div class="buttons">
            <Button on:click={modalStore.close} text="Cancelar" icon="ban" color="light" />
            <Button type="submit" text="Guardar" icon="save" color="primary" { loading } />
        </div>
    </div>
</Form>